import { ShellConfig } from '@gc-bridge/models';
import { isRemoteInMaintenanceMode } from '@gcportal/base';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

export const DEFAULT_CONFIG_TTL = 10 * 60 * 1000; // 10 minutes

interface ConfigStore {
  config: ShellConfig | undefined;
  setConfig: (config: ShellConfig) => void;
}

export const useConfigStore = create<ConfigStore>()(
  subscribeWithSelector((set) => ({
    config: undefined,
    setConfig: (config) => set({ config }),
  }))
);

/**
 * Helper function to wait for maintenance mode to end for a specific remote.
 * This is used by axios interceptors to pause requests until maintenance is complete.
 */
export function waitForMaintenanceEnd(
  remoteName: string,
  currentUserGroups?: string[]
): Promise<void> {
  return new Promise((resolve) => {
    const unsubscribe = useConfigStore.subscribe(
      (state) => state.config,
      (config) => {
        if (!config) {
          return;
        }

        const remote = config.remotes.find((remote) => remote.name === remoteName);

        if (remote && !isRemoteInMaintenanceMode(remote, currentUserGroups)) {
          unsubscribe();
          resolve();
        }
      },
      { fireImmediately: false } // Only fire on changes, not on initial subscription
    );
  });
}
